import axios from 'axios';
import { Configuration, ChannelApiFactory, ProductOrderAdminApiFactory, OrdersReportApiFactory } from '@cdaas/api-clients/dist/order-admin-openapi';

const orderAdminConfig = new Configuration({
  basePath: process.env.REACT_APP_ORDER_ADMIN_SERVICE_URL,
});

export const orderAdminChannelClient = ChannelApiFactory(orderAdminConfig, undefined, axios);
export const orderAdminProductOrderClient = ProductOrderAdminApiFactory(orderAdminConfig, undefined, axios);
export const orderAdminReportClient = OrdersReportApiFactory(orderAdminConfig, undefined, axios);
